import api from "../../request/service/openClassApi";

const user = {
	state: {
		user: {},
	},

	mutations: {
		SET_USER: (state, user) => {
			state.user = user;
		},
	},

	actions: {
		// 登录
		Login({ commit }, userInfo) {
			return new Promise((resolve, reject) => {
				api.login(
					userInfo.username,
					userInfo.password,
					userInfo.loginUserType,
					userInfo.code
				)
					.then((res) => {
						commit("SET_USER", res ? res.infoObject : {});
						console.log(res)
						resolve(res);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
	},
};

export default user;
